// Canonical access rule for the Stripe Connect module.
//
// Sidebar visibility and the route guard both read this, so the nav link can
// never appear for someone the routes would bounce, or vice versa. Same shape
// as payment_processor_config/access.ts — see that file for the fuller notes.
//
// Grant "Stripe Connect → Access" (STRIPE_CONNECT_ACCESS) to a role in the
// Role editor to expose the page for that role. Ronin admins (role_id 1)
// always have it.
//
// NOTE: this governs who reaches the PAGE. The destructive in-page actions
// (unlink / relink / deauthorize) and test-mode creation stay gated on the
// JWT's x-hasura-default-role === "admin", because that is what ronin-api
// itself enforces on /api/stripeConnect/*. Do not re-point those at this
// permission without changing the backend to match, or the UI will offer
// buttons the API will refuse.

export const stripeConnectAccessFor = (user: any) => {
  const granted: any[] = user?.role?.permissions?.stripe_connect ?? [];
  const isAdmin = user?.role_id === 1;

  return {
    access:
      isAdmin ||
      granted.some(
        (entry) =>
          typeof entry?.value === "string" &&
          entry.value === "STRIPE_CONNECT_ACCESS"
      ),
  };
};

export type StripeConnectCapability = keyof ReturnType<
  typeof stripeConnectAccessFor
>;
